import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetOtherIncomes = async (params: {
  page: number;
  limit: number;
  search?: string;
  store_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/other-incomes`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load other incomes.",
      data: { data: [], total: 0 },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateOtherIncome = async (payload: {
  source: string;
  amount: number;
  income_date: string;
  payment_method_id: string;
  bank_account_id?: string | null;
  transaction_no?: string | null;
  reference_no?: string | null;
  cheque_no?: string | null;
  bank_name?: string | null;
  cheque_date?: string | null;
  note?: string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/other-incomes/create`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to log other income.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteOtherIncome = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/other-incomes/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete other income.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
